<div #chartParent class="chart-container mb-6">
</div>
@if (!data || data.length===0) {
  <h5>No Data Available</h5>
}

